import React, { Component } from "react";
import { Table, Image, Button, Tag, Badge, Progress, Switch } from "antd";
import ImageWall from "./ImageWall";
import orderedTag from "./orderTag";
import ImageListPreview from "../../components/ImageListPreview";
import AssessmentTag from "../../components/AssessmentTag";

const renderImagesPreview = (r) => {
  const images = r.images;
  var nImages = images.length;
  if (nImages > 5) {
    nImages = 5;
  }
  return (
    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
      <ImageListPreview
        images={images.slice(0, nImages)}
        width={50}
        height={50}
      ></ImageListPreview>
    </div>
  );
};

const renderNumberOfImages = (r) => {
  const numberOfImages = r.n_images;
  var color = "#40A9FF";

  switch (numberOfImages) {
    case 0:
      color = "#FF7875";
      break;

    case 1:
      color = "#91D5FF";
      break;

    default:
      break;
  }

  return <Badge count={numberOfImages} showZero color={color} />;
};

const shortenText = (t) => {
  const maxNumberOfChar = 40;
  var text = t;
  if (text.length > maxNumberOfChar) {
    text = text.slice(0, maxNumberOfChar) + "...";
  }

  return text;
};

const columns = [
  {
    title: "Artilcle",
    dataIndex: "article",
    key: "article",
    width: "33%",
    render: (t, r) => (
      <Button target="_blank" type="link" href={r.article_link}>
        {shortenText(t)}
      </Button>
    ),
    sorter: {
      compare: (a, b) => a.article.localeCompare(b.article),
      multiple: 1,
    },
  },
  {
    title: "Quality",
    dataIndex: "quality",
    key: "quality",
    width: "12%",
    render: (t, r) => <AssessmentTag type="quality" text={r.quality} />,
    sorter: {
      compare: (a, b) =>
        orderedTag(a.quality).localeCompare(orderedTag(b.quality)),
      multiple: 2,
    },
    defaultSortOrder: "ascend",
  },
  {
    title: "Importance",
    dataIndex: "importance",
    key: "importance",
    width: "12%",
    render: (t, r) => <AssessmentTag type="importance" text={r.importance} />,
    sorter: {
      compare: (a, b) =>
        orderedTag(a.importance).localeCompare(orderedTag(b.importance)),
      multiple: 3,
    },
    defaultSortOrder: "ascend",
  },
  {
    title: "Number of images",
    dataIndex: "n_images",
    key: "n_images",
    width: "13%",
    render: (t, r) => renderNumberOfImages(r),
    sorter: {
      compare: (a, b) => a.n_images - b.n_images,
      multiple: 4,
    },
    defaultSortOrder: "ascend",
  },
  {
    title: "Images",
    dataIndex: "images",
    render: (t, r) => renderImagesPreview(r),
  },
];

export default class ArticlesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOnlyImages: false,
    };
  }

  onChangeSwitch = (checked) => {
    this.setState({
      showOnlyImages: checked,
    });
  };

  getImages = (data) => {
    var allImages = this.props.data.map((a) => a.images);
    allImages = [].concat.apply([], allImages);

    return allImages;
  };

  render() {
    const { showOnlyImages } = this.state;
    return (
      <>
        <span>
          <b>{this.props.data.length} Articles</b> (total <span> </span>
          {this.props.numberOfArticles})
        </span>
        <span>
          Show only images<span> </span>
          <Switch onChange={this.onChangeSwitch} />
        </span>

        <Progress
          percent={(this.props.data.length / this.props.numberOfArticles) * 100}
          size="small"
          status="active"
          showInfo={false}
        />
        <div style={{ height: "20px", width: "100%" }}></div>
        {(() => {
          if (showOnlyImages) {
            return (
              <ImageWall data={this.getImages(this.props.data)}></ImageWall>
            );
          } else {
            return (
              <Table
                style={{ width: "100%" }}
                bordered
                dataSource={this.props.data}
                columns={columns}
                pagination={{ position: ["bottomCenter"] }}
              />
            );
          }
        })()}
      </>
    );
  }
}
